// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import HELPCENTER_CONSTANTS from '../HelpCenterNew.constants';

export default css`
  &.helpcenter__view {
    padding: 60px 60px 248px 60px;
    background-color: #f9f9f9;
    position: relative;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      padding: 24px 24px 248px 24px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding: 24px 24px 351px 24px;
    }
    & .help-center-footer-container {
      position: absolute;
      width: 100%;
      left: 0px;
      bottom: 0px;
      margin-top: 14px;
    }
    & .help-center-header-container {
      position: absolute;
      width: 100%;
      left: 0px;
      top: 0px;
    }
    & .styled-column {
      background: white;
      border-radius: 8px;
      padding-bottom: 30px;
      justify-content: flex-start;
      align-items: flex-start;
      box-sizing: border-box;
    }
    & .styled-column > *:not(:last-child) {
      margin-bottom: 0px;
    }
    & .module_container_column {
      position: relative;
    }
    & .help-center__header-text {
      display: none;
      font-size: 32px;
      position: absolute;
      font-weight: 600;
      line-height: 44px;
      top: -115px;
      z-index: 1;
    }
    & .trackorder__form {
      margin-top: 28px;
      & .track__order__form_container {
        margin-bottom: 10px;
      }
    }

    & .TrackOrder__Modal {
      width: 250px !important;
    }

    & .track_order_round_textbox__capsule {
      height: 38px !important;
      padding-left: 0px;
      width: 91% !important;
    }
    & .input-fields-wrapper .TextBox__capsule_extra_padding {
      top: 6px;
      font-size: 14px;
      color: #525252;
      line-height: 20px;
    }
    & .trackOrder__button {
      padding: 9px;
      height: 40px;
      width: 96px;
      font-weight: 800;
      font-size: 14px;
      line-height: 24px;
    }
    & .showonlyInDesktop .nav-link-wrapper {
      padding: 15px 0px;
      border-top: 1px solid #d8d8d8;
    }
    & .showonlyInDesktop .nav-link-wrapper .navLink {
      color: #000000;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
    }
    & .showonlyInDesktop .nav-link-wrapper .navLink__Selected {
      color: #000000;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
    }
    & .showonlyInDesktop .nav-link-wrapper:last-child {
      border-bottom: 1px solid #d8d8d8;
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      & .help-center-footer-container {
        min-height: 342px;
      }
      & .TrackOrder__Modal {
        border-radius: 8px;
        margin-top: 20px;
        margin-bottom: 30px;
        width: 100% !important;
        padding: 20px 0px;
        background: white;
      }
      & .trackorder__heading,
      .trackorder__customer__service__heading {
        padding-bottom: 0px;
        border-bottom: none;
      }
      & .trackorder_container {
        margin: 0px;
        padding: 0px 20px;
      }
      & .trackorder__form {
        margin-top: 17px;
      }
      & .trackorder__form .elem-mb-LRG {
        margin: 0px;
      }
      & .TextBox_view {
        border: none;
        padding-left: 18px;
        background: #f5f5f5;
        color: #525252;
      }
      & .trackorder__footer__customer_service {
        margin-top: 0px;
        padding-bottom: 0px;
        border-bottom: none;
      }
      & .trackorder_customer__service_container {
        padding: 0px 20px;
      }
      & .accordion {
        font-weight: 600;
        background: #f7f7f7;
        font-size: 16px;
        line-height: 26px;
        min-height: 0px;
        padding: 0px;
      }
      & .accordion.inactive {
        background: #f7f7f7;
      }
      & .list-item {
        padding: 14px 10px;
        border-top: 1px solid #d8d8d8;
      }
      & .container-accordion:last-child .list-item:last-child {
        border-bottom: 1px solid #d8d8d8;
      }
      & .inactive::after {
        width: 14.55px;
        margin-top: 12px;
      }
      & .active::after {
        transform: scale(1.17);
        margin-top: -2px;
      }
      & .styled-column {
        padding: 20px !important;
      }
      & .module_container_column .container-accordion .styled-column {
        padding-left: 2px !important;
        padding-top: 25px !important;
        background: #f7f7f7;
        margin-bottom: 0px !important;
      }
      &
        .module_container_column
        .container-accordion:nth-child(2)
        .list-item.item-active:first-child
        .accordion {
        background: white;
      }
      &
        .module_container_column
        .container-accordion:nth-child(2)
        .list-item.item-active:first-child {
        border-top: none;
        border-bottom: none;
        background: white;
      }
      & .module_container_column .container-accordion:nth-child(2) .list-item:first-child {
        margin-top: 20px;
        border-bottom: 1px solid #d8d8d8;
      }
      &
        .module_container_column
        .container-accordion:nth-child(2)
        .list-item:first-child
        .item-content
        .styled-column {
        background: white;
      }
      & .dropDownLists > div {
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
      }
      & .styled-column > div:not(:first-child) {
        padding-right: 20px;
      }
      & .item-active .styled-column > div:first-child {
        display: none;
      }
      & .customSelectArrow {
        right: 6px;
      }
      & .dropdownUlBorder {
        box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.1);
        padding-bottom: 9px;
        border: none;
        background-color: #f9f9f9;
      }
      & .dropDownLists {
        margin: 0px 24px;
        color: #000000;
        padding: 13px 0px;
        border-bottom: 1px solid #e5e5e5;
      }
      & .dropDownLists:last-child {
        border-bottom: none;
      }
      & .customSelectTitle {
        margin: 0px 24px;
        text-align: left;
        font-weight: 600;
        font-size: 20px;
        line-height: 25px;
        padding: 14px 0px;
        background-color: #f9f9f9;
        border: none;
        border-bottom: 1px solid #e5e5e5;
      }
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      & .help-center__header-text {
        display: block;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      & .helpCenterModuleTwoCol .showonlyInMobile {
        z-index: 1;
        position: absolute;
        left: 0px;
        width: 100vw;
        top: 155px;
        margin: 0px 0px 36px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      & .help-center-footer-container {
        margin-top: 55px;
      }
      & .styled-column {
        position: relative;
        padding-top: 73px;
        flex-wrap: wrap;
        overflow-x: auto;
        ${(props) =>
          props.selectedPage === HELPCENTER_CONSTANTS.HELP_CENTER_ROUTES.HOME &&
          'max-height: 336px;'}
      }
      & .styled-column:not(:last-child) {
        margin-right: 20px;
      }
      & .dropDownLists > div {
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        line-height: 26px;
      }
      & .styled-column > div:first-child {
        width: calc(100% - 58px) !important;
        position: absolute;
        top: 30px;
        left: 30px;
      }
      & .styled-column > div:not(:first-child) {
        padding-right: 30px;
        padding-left: 30px;
      }
      & .styled-container:not(:last-child) {
        margin-bottom: 20px;
      }
    }

    & .styled-column > div:not(:first-child) {
      box-sizing: border-box;
    }

    && .styled-column:not(:last-child) > * {
      margin-bottom: unset;
      ${(props) =>
        props.selectedPage === HELPCENTER_CONSTANTS.HELP_CENTER_ROUTES.HOME
          ? 'width: auto;'
          : 'width: 100%;'}
    }
    & .styled-column > div:first-child {
      width: 100%;
    }
    & .link-text {
      margin-bottom: 0 !important;
      align-items: start;
      flex-direction: row;
      justify-content: flex-start;
    }
    & p[locator='moduleContainer_header_text'] {
      position: relative;
    }
    & .styled-column > div:first-child span:last-child {
      flex-grow: 1;
    }

    & .styled-column > *:last-child .help_center_link {
      margin-bottom: unset;
    }
    & .customSelectArrow {
      right: 6px;
    }
    & .dropdownUlBorder {
      box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.1);
      padding-bottom: 9px;
      border: none;
      background-color: #f9f9f9;
    }
    & .dropDownLists {
      margin: 0px 24px;
      color: #000000;
      padding: 13px 0px;
      border-bottom: 1px solid #e5e5e5;
    }
    & .dropDownLists:last-child {
      border-bottom: none;
    }
    & .customSelectTitle {
      margin: 0px 24px;
      text-align: left;
      font-weight: 600;
      font-size: 20px;
      line-height: 25px;
      padding: 14px 0px;
      background-color: #f9f9f9;
      border: none;
      border-bottom: 1px solid #e5e5e5;
    }
  }
`;
